var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2371 6.53516H4.76172C4.672 6.53516 4.58504 6.54697 4.50231 6.56913L10.9383 13.0051C11.5241 13.5909 12.4739 13.5909 13.0596 13.0051L19.4958 6.56895C19.4133 6.54691 19.3266 6.53516 19.2371 6.53516ZM3.76172 7.53516C3.76172 7.44572 3.77346 7.35902 3.79549 7.27652L8.52074 12.0018L3.79559 16.7269C3.7735 16.6443 3.76172 16.5575 3.76172 16.4679V7.53516ZM4.50268 17.434C4.5853 17.4561 4.67213 17.4679 4.76172 17.4679H19.2371C19.3264 17.4679 19.413 17.4562 19.4955 17.4342L14.7703 12.7091L13.6589 13.8204C12.7422 14.7372 11.2558 14.7372 10.339 13.8204L9.22767 12.7091L4.50268 17.434ZM20.203 16.7276C20.2253 16.6448 20.2371 16.5577 20.2371 16.4679V7.53516C20.2371 7.44547 20.2253 7.35854 20.2031 7.27584L15.4772 12.0018L20.203 16.7276ZM4.76172 5.53516C3.65715 5.53516 2.76172 6.43059 2.76172 7.53516V16.4679C2.76172 17.5725 3.65715 18.4679 4.76172 18.4679H19.2371C20.3417 18.4679 21.2371 17.5725 21.2371 16.4679V7.53516C21.2371 6.43059 20.3417 5.53516 19.2371 5.53516H4.76172Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.79162721.svg";
export { ForwardRef as ReactComponent };